import { Color } from '../color/Color'
import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum DocumentPaymentStatusId {
  PAID = 1,
  NOT_PAID = 0,
  PARTLY_PAID = 2,
  OVERPAID = 3,
}

export class DocumentPaymentStatus {
  static readonly PAID = new DocumentPaymentStatus(
    DocumentPaymentStatusId.PAID,
    'paid',
    () => $t('Paid'),
    Color.POSITIVE,
  )
  static readonly NOT_PAID = new DocumentPaymentStatus(
    DocumentPaymentStatusId.NOT_PAID,
    'not-paid',
    () => $t('Unpaid'),
    Color.NEGATIVE,
  )
  static readonly PARTLY_PAID = new DocumentPaymentStatus(
    DocumentPaymentStatusId.PARTLY_PAID,
    'partly-paid',
    () => $t('Partially paid'),
    Color.WARNING,
  )
  static readonly OVERPAID = new DocumentPaymentStatus(
    DocumentPaymentStatusId.OVERPAID,
    'overpaid',
    () => $t('Overpaid'),
    Color.INFO,
  )

  private constructor(
    public readonly id: DocumentPaymentStatusId,
    public readonly name: string,
    public readonly label: () => string,
    public readonly color: Color.NEGATIVE | Color.POSITIVE | Color.WARNING | Color.INFO,
  ) {}

  static getById = (id: DocumentPaymentStatusId): DocumentPaymentStatus => {
    const value = DocumentPaymentStatus.all().find((item: DocumentPaymentStatus) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(DocumentPaymentStatus.name, id)
    }

    return value
  }

  static all = (): DocumentPaymentStatus[] => {
    return [
      DocumentPaymentStatus.PAID,
      DocumentPaymentStatus.NOT_PAID,
      DocumentPaymentStatus.PARTLY_PAID,
      DocumentPaymentStatus.OVERPAID,
    ]
  }
}
